import { render, staticRenderFns } from "./AppointmentBranchDialog.vue?vue&type=template&id=93016212&"
import script from "./AppointmentBranchDialog.vue?vue&type=script&lang=js&"
export * from "./AppointmentBranchDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentBranchDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports